import { FrameName } from "../config";
import ShallowSeaSmallFishTrapBuildingTileEntity from "./ShallowSeaSmallFishTrapBuildingTileEntity";

class ShallowSeaMediumFishTrapBuildingTileEntity extends ShallowSeaSmallFishTrapBuildingTileEntity {
	public static readonly frameName = FrameName.SHALLOW_SEA_MEDIUM_FISH_TRAP;
}

export default ShallowSeaMediumFishTrapBuildingTileEntity;
